import Axios, { type AxiosInstance } from 'axios';
import { aemApiConfig } from '@/util/configs';
import type { AemuiExperiencePutRequest } from 'Types/aemui/experiences/experiences';

export const ExperienceServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: aemApiConfig.url + '/member-experiences',
	headers: {
		apiKey: aemApiConfig.key
	}
});

class ExperienceService {
	axiosInstance: AxiosInstance = ExperienceServiceAxiosInstance;

	put(payload: AemuiExperiencePutRequest) {
		return this.axiosInstance.put('/experiences', payload);
	}
}

export const experienceService = new ExperienceService();
